export const DEFAULT_FONT_COLOR = 'FFFFFF';
export const TITLE_SLIDE_MASTER = 'TITLE_SLIDE';
export const NAVIGATING_COMPLEXITY_SLIDE = 'NAVIGATING_COMPLEXITY';
export const COVER_SLIDE = 'COVER_SLIDE';
export const DEFAULT_FONT = 'Montserrat';
export const DEFAULT_FILENAME = 'End of Campaign Report.pptx';
export const MAX_RECOMMENDATIONS = 4;
export const MAX_TEAM_MEMBERS = 4;
export const MAX_OBSERVATIONS = 3;
